import type { SearchableField } from "@salon/types";

export const ONLINE_BOOKING_SEARCH: SearchableField[] = [
  {
    id: "online_booking.enabled",
    sectionId: "online",
    labelKey: "search.onlineBooking.enabled.label",
    descriptionKey: "search.onlineBooking.enabled.description",
    keywordsKey: "search.onlineBooking.enabled.keywords",
    anchor: "field-online-enabled",
  },
  {
    id: "online_booking.slots_per_hour",
    sectionId: "online",
    labelKey: "search.onlineBooking.slotsPerHour.label",
    descriptionKey: "search.onlineBooking.slotsPerHour.description",
    keywordsKey: "search.onlineBooking.slotsPerHour.keywords",
    anchor: "field-online-slots-per-hour",
  },
  {
    id: "online_booking.lead_minutes_from_now",
    sectionId: "online",
    labelKey: "search.onlineBooking.leadFromNow.label",
    descriptionKey: "search.onlineBooking.leadFromNow.description",
    keywordsKey: "search.onlineBooking.leadFromNow.keywords",
    anchor: "field-online-lead-from-now",
  },
  {
    id: "online_booking.lead_minutes_from_opening",
    sectionId: "online",
    labelKey: "search.onlineBooking.leadFromOpening.label",
    descriptionKey: "search.onlineBooking.leadFromOpening.description",
    keywordsKey: "search.onlineBooking.leadFromOpening.keywords",
    anchor: "field-online-lead-from-opening",
  },
  {
    id: "online_booking.trail_minutes_before_closing",
    sectionId: "online",
    labelKey: "search.onlineBooking.trailBeforeClosing.label",
    descriptionKey: "search.onlineBooking.trailBeforeClosing.description",
    keywordsKey: "search.onlineBooking.trailBeforeClosing.keywords",
    anchor: "field-online-trail-before-closing",
  },
  {
    id: "online_booking.advance_booking_days",
    sectionId: "online",
    labelKey: "search.onlineBooking.advanceBookingDays.label",
    descriptionKey: "search.onlineBooking.advanceBookingDays.description",
    keywordsKey: "search.onlineBooking.advanceBookingDays.keywords",
    anchor: "field-online-advance-booking-days",
  },
  {
    id: "online_booking.worker_selection_enabled",
    sectionId: "online",
    labelKey: "search.onlineBooking.workerSelectionEnabled.label",
    descriptionKey: "search.onlineBooking.workerSelectionEnabled.description",
    keywordsKey: "search.onlineBooking.workerSelectionEnabled.keywords",
    anchor: "field-online-worker-selection-enabled",
  },
  {
    id: "online_booking.service_selection_mode",
    sectionId: "online",
    labelKey: "search.onlineBooking.serviceSelectionMode.label",
    descriptionKey: "search.onlineBooking.serviceSelectionMode.description",
    keywordsKey: "search.onlineBooking.serviceSelectionMode.keywords",
    anchor: "field-online-service-selection-mode",
  },
  {
    id: "online_booking.worker_selection_mode",
    sectionId: "online",
    labelKey: "search.onlineBooking.workerSelectionMode.label",
    descriptionKey: "search.onlineBooking.workerSelectionMode.description",
    keywordsKey: "search.onlineBooking.workerSelectionMode.keywords",
    anchor: "field-online-worker-selection-mode",
  },
  {
    id: "online_booking.allow_booking_past_closing",
    sectionId: "online",
    labelKey: "search.onlineBooking.allowBookingPastClosing.label",
    descriptionKey: "search.onlineBooking.allowBookingPastClosing.description",
    keywordsKey: "search.onlineBooking.allowBookingPastClosing.keywords",
    anchor: "field-online-allow-past-closing",
  },
  {
    id: "online_booking.bank_transfer_enabled",
    sectionId: "online",
    labelKey: "search.onlineBooking.bankTransferEnabled.label",
    descriptionKey: "search.onlineBooking.bankTransferEnabled.description",
    keywordsKey: "search.onlineBooking.bankTransferEnabled.keywords",
    anchor: "field-online-bank-transfer-enabled",
  },
];
